import dedent from 'ts-dedent'
import {
  ColumnDataType,
  GetOutputSchemaParams,
  Provider,
  TableSchema,
  WorkflowComponentCodeParams,
  WorkflowComponentParamType
} from '../types'
import { addColumn } from '../utils/schemas'
import { SelectWorkflowComponent } from './common/selectcomponent'

class MakePolygon extends SelectWorkflowComponent {
  constructor() {
    super(
      {
        name: 'native.makepolygon',
        group: 'Spatial Constructors',
        title: 'ST Make Polygon',
        description: `
      This component creates a Polygon based on another column containing lines.
      `
      },
      [
        {
          name: 'source',
          type: WorkflowComponentParamType.InputTable,
          title: 'Source table'
        },
        {
          name: 'lines',
          type: WorkflowComponentParamType.Column,
          title: 'Polylines column',
          parent: 'source',
          dataType: [ColumnDataType.Geography, ColumnDataType.Geometry]
        }
      ]
    )
  }

  getInnerSql({ params, connection }: WorkflowComponentCodeParams) {
    switch (connection.type) {
      case Provider.BigQuery:
      case Provider.Snowflake:
      case Provider.Postgres:
      case Provider.Redshift:
        return dedent`SELECT
                        ${connection.processOutputGeogColumn(
                          `ST_MAKEPOLYGON(${connection.processInputGeogColumn(params.lines as string)})`
                        )}
                        AS ${params.lines}_polygons, *
                      FROM ${connection.quoteName(params.source as string)}`
      case Provider.DatabricksRest:
        return dedent`SELECT /*+ REPARTITION(40, geom) */
                  ${connection.processOutputGeogColumn(
                    `ST_MAKEPOLYGON(${connection.processInputGeogColumn(params.lines as string)})`
                  )}
                  AS ${params.lines}_polygons, *
                FROM ${connection.quoteName(params.source as string)}`
      case Provider.Oracle:
        return dedent`SELECT
                        CASE
                          WHEN ${params.lines}.SDO_GTYPE = 2002 THEN
                            SDO_GEOMETRY(
                              2003,
                              ${params.lines}.SDO_SRID,
                              NULL,
                              ${params.lines}.SDO_ELEM_INFO,
                              ${params.lines}.SDO_ORDINATES
                            )
                          ELSE ${params.lines}
                        END AS ${params.lines}_polygons, *
                      FROM ${connection.quoteName(params.source as string)}`
      default:
        return null
    }
  }

  canProvideOutputSchemas(): boolean {
    return true
  }

  getOutputSchema({ columns, params, connection }: GetOutputSchemaParams): TableSchema {
    return addColumn(columns.source, {
      name: `${params.lines}_polygons`,
      type: connection.getGeoDataType()
    })
  }
  supportedProviders(): Provider[] {
    return [
      Provider.BigQuery,
      Provider.Postgres,
      Provider.Redshift,
      Provider.Snowflake,
      Provider.DatabricksRest,
      Provider.Oracle
    ]
  }
}

export { MakePolygon }
